module.exports = __webpack_public_path__ + "img/logo_opensea.fa391a9d.png";